import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    FetchInventoryStockAdjustmentsInput,
    InventoryStockAdjustmentsFeedResponse,
} from '../../types/inventory';

const fetchStockAdjustments = async (
    sessionId: string,
    input: FetchInventoryStockAdjustmentsInput,
): Promise<InventoryStockAdjustmentsFeedResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/adjustments/feed`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useGetInventoryStockAdjustments = (
    inventoryItemId: string | undefined,
    limit: number,
    offset: number,
    enabled = true,
) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/inventory/adjustments/feed', inventoryItemId, limit, offset],
        queryFn: () =>
            fetchStockAdjustments(sessionContext?.sessionId ?? '', {
                inventoryItemId: inventoryItemId!,
                limit,
                offset,
            }),
        enabled: !!sessionContext?.sessionId && !!inventoryItemId && enabled,
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
    });
};
